/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_mobile_analytics_app_id": "98df0a8759344c549e69b9a1e9afa786",
    "aws_mobile_analytics_app_region": "eu-west-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "98df0a8759344c549e69b9a1e9afa786",
            "region": "eu-west-1"
        }
    },
    "aws_cognito_identity_pool_id": "eu-west-1:274ea52b-2b0b-456d-80b4-484e0caebee1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_vGtRSIg9u",
    "aws_user_pools_web_client_id": "477v9lqhrogbferlhsaa9revsl",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_user_files_s3_bucket": "bsportaal155758-master",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
